import {
    addFavoriteRequest,
    deleteFavoriteRequest,
} from '../../../services/network/common/favorite';

class CommonFavoriteService {
    async addFavorite(advertId) {
        return await addFavoriteRequest(advertId);
    }

    async deleteFavorite(id) {
        return await deleteFavoriteRequest(id);
    }
}

export const FavoriteService = new CommonFavoriteService();
